import { useMemo } from "react";

import CreateBudgetStepper from "./CreateBudgetSteper/CreateBudgetStepper";
import { useNewBudgetData } from "./useNewBudgetData";

export const CreateBudgetWrapper = () => {
  const newBudgetData = useNewBudgetData();

  const budget = useMemo(
    () => ({
      data: newBudgetData,
    }),
    [newBudgetData]
  );

  return <CreateBudgetStepper budget={budget} isNewBudget={true} />;
};
